export const RESTRICTED_EMAILS = Object.freeze([])

export const isRestrictedEmail = (email) => {
  if (!email || typeof email !== 'string') return false
  return RESTRICTED_EMAILS.includes(email.trim().toLowerCase())
}

export const filterRestrictedEmails = (recipients) => {
  if (!recipients) return []

  if (Array.isArray(recipients)) {
    return recipients.filter((item) => {
      const addr = typeof item === 'string' ? item : item?.address
      return !isRestrictedEmail(addr)
    })
  }

  if (typeof recipients === 'string') {
    return recipients
      .split(',')
      .map((item) => item.trim())
      .filter((addr) => addr && !isRestrictedEmail(addr))
  }

  return []
}
